import { DropdownOption, dropdownOption } from 'components/dropdown'

export enum IndexName {
  EVENTS = 'email-events',
  POSTS = 'mrd.posts',
  TAGS = 'tags',
}

//tslint:disable-next-line
export const DateDescriptors = {
  LastMonthEnd: 'now/M',
  LastMonthStart: 'now-1M/M',
  LastMonthWeekStart: 'now-1M/w',
  LastWeekEnd: 'now/w',
  LastWeekStart: 'now-1w/w',
  Now: 'now',
  OneDayAgo: 'now-1d',
  PastDayStart: 'now-1d/d',
  PastMonthStart: 'now-1M/d',
  PastNinetyDayStart: 'now-90d/d',
  PastSixtyDayStart: 'now-60d/d',
  PastWeekStart: 'now-1w/d',
  PastYearStart: 'now-1y/d',
  TodayStart: 'now/d',
  YesterdayEnd: 'now/d',
}

export const DELIMITER = '|'
//tslint:disable-next-line
export const DateRanges = {
  LastMonth: `${DateDescriptors.LastMonthStart}${DELIMITER}${DateDescriptors.LastMonthEnd}`,
  LastWeek: `${DateDescriptors.LastWeekStart}${DELIMITER}${DateDescriptors.LastWeekEnd}`,
  PastDay: `${DateDescriptors.OneDayAgo}${DELIMITER}${DateDescriptors.Now}`,
  PastMonth: `${DateDescriptors.PastMonthStart}${DELIMITER}${DateDescriptors.YesterdayEnd}`,
  PastWeek: `${DateDescriptors.PastWeekStart}${DELIMITER}${DateDescriptors.YesterdayEnd}`,
  PastYear: `${DateDescriptors.PastYearStart}${DELIMITER}${DateDescriptors.YesterdayEnd}`,
  Today: `${DateDescriptors.TodayStart}${DELIMITER}${DateDescriptors.Now}`,
  Yesterday: `${DateDescriptors.PastDayStart}${DELIMITER}${DateDescriptors.YesterdayEnd}`,
  WeeklyAverage: `${DateDescriptors.LastMonthWeekStart}${DELIMITER}${DateDescriptors.LastWeekEnd}`,
  PastSixtyDays: `${DateDescriptors.PastSixtyDayStart}${DELIMITER}${DateDescriptors.Now}`,
  PastNinetyDay: `${DateDescriptors.PastNinetyDayStart}${DELIMITER}${DateDescriptors.Now}`,
}

export const AggregationIntervals = {
  Day: 'day',
  Month: 'month',
  Week: 'week',
}

export const AggregateIntervalOptions: DropdownOption[] = [
  {key: '1', value: AggregationIntervals.Day, description: 'Group by day'},
  {key: '2', value: AggregationIntervals.Week, description: 'Group by week'},
  {key: '3', value: AggregationIntervals.Month, description: 'Group by month'},
]

export const intervalDropdownOption = (interval: string): DropdownOption => {
  return dropdownOption(interval, AggregateIntervalOptions)
}

export enum AggregationType {
  cardinality = 'cardinality',
  date_histogram = 'date_histogram',
  terms = 'terms',
}

export enum FilterType {
  exists = 'exists',
  term = 'term',
  terms = 'terms',
  range = 'range',
}

